<div id="resultsGroup" class="container">
    <div class="header row no-gutters">
        <div class="navigation col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <h2 class="results-title selenium-search-results-count" #title>
                        {{ resultsCount }} search results
                    </h2>
                </div>
                <div
                    class="selenium-search-results-suggestion spell col-xs-12 col-sm-12 col-md-12 col-lg-12"
                    *ngIf="didYouMeanSuggestions.highlighted"
                >
                    <span>Did you mean:</span>
                    <a (click)="onDidYouMeanClick()">
                        <i [innerHTML]="didYouMeanSuggestions.highlighted"></i>
                    </a>
                </div>
                <div class="mobile-filters-wrapper">
                    <app-mobile-search-top-section></app-mobile-search-top-section>
                </div>
                <div class="sort-by-wrapper">
                    <app-rank-by [isOnSearch]="true"></app-rank-by>
                </div>
            </div>
            <div class="row d-none d-sm-none d-md-block">
                <div class="col-xs-12 com-sm-12 col-md-12 col-lg-12">
                    <app-applied-filters></app-applied-filters>
                </div>
            </div>
        </div>
    </div>
    <div class="search-group">
        <div class="search-group-inner">
            <div *ngIf="!loadingResults" class="search-items row">
                <div
                    class="search-item {{ bootstrapClasses }} selenium-search-results-item"
                    *ngFor="let learningObject of learningObjectResults; let i = index"
                >
                    <!-- INFO: data-gtmresultindex formula:
                            substract 1 from current page; this will be always ahead of card numbers
                            add 1 to index provided by *ngFor; it starts from 0 -->
                    <app-collection-search-card
                        class="mb-4"
                        *ngIf="learningObject.isCollection"
                        [learningObject]="learningObject"
                        [gtmPrefix]="gtmPrefix"
                        [gtmDataCardNumber]="(currentPage - 1) * 10 + i + 1"
                    >
                    </app-collection-search-card>
                    <app-resource-search-card
                        class="mb-4"
                        *ngIf="!learningObject.isCollection"
                        [learningObject]="learningObject"
                        [gtmPrefix]="'gtm-results-search-card'"
                        [gtmDataCardNumber]="(currentPage - 1) * 10 + i + 1"
                    >
                    </app-resource-search-card>
                </div>
            </div>

            <div *ngIf="loadingResults" class="search-items placeholder row">
                <div
                    class="search-item {{
                        bootstrapClasses
                    }} selenium-search-results-item-placeholder          "
                    *ngFor="let result of resultsPlaceholder"
                >
                    <app-element-placeholder [type]="'inline'"></app-element-placeholder>
                </div>
            </div>

            <app-pagination
                (goPage)="goToPage($event)"
                (goNext)="onNext()"
                (goPrev)="onPrev()"
                (goFirst)="onFirst()"
                (goLast)="onLast()"
                (click)="scrollTo(title)"
                [loading]="loadingResults"
                [pagesToShow]="7"
                [page]="currentPage"
                [perPage]="resultsPerPage"
                [count]="totalResultsForPagination"
            ></app-pagination>
        </div>
    </div>
</div>
